import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../../assets/images/weather/太阳@2x.png';
const _withScopeId = n => (_pushScopeId("data-v-d2966e6e"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "index_head"
};
const _hoisted_2 = {
  class: "head_left"
};
const _hoisted_3 = {
  class: "time"
};
const _hoisted_4 = {
  class: "timer"
};
const _hoisted_5 = {
  class: "date"
};
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<span class=\"title\" data-v-d2966e6e>北国之春农业园区大数据</span><div class=\"head_right\" data-v-d2966e6e><div class=\"weather\" data-v-d2966e6e><div class=\"icon\" data-v-d2966e6e><img src=\"" + _imports_0 + "\" alt=\"\" data-v-d2966e6e><div class=\"text\" data-v-d2966e6e>晴朗</div></div><div class=\"temp\" data-v-d2966e6e>20℃</div></div></div>", 2);
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.nowTime.split(' ')[1]), 1), _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.nowTime.split(' ')[0]) + _toDisplayString(_ctx.week), 1)])]), _hoisted_6]);
}